import type { Router } from 'vue-router'

/** `utm_content` as it arrived on the landing URL, kept after the address bar has been cleaned. */
let landingUtmContent = ''

/** The `utm_content` this visit landed with, or `''` if there was none. */
export const getLandingUtmContent = () => landingUtmContent

/**
 * Reads `utm_content` off the landing URL once, then strips it from the address bar so it is not
 * carried into the next navigation — several places in the app forward the current query when they
 * push a route (e.g. the pagination in `NewsList.vue`), which would otherwise smear one link's attribution
 * across every page the visitor clicks afterwards.
 *
 * Timing matters: GTM is injected into <head> by VitePluginRadar and fires its landing pageview
 * before the Vue app mounts, so the tag has already recorded the original URL by the time this runs.
 * Calling it any earlier would strip the parameter out from under GA.
 *
 * Uses `router.replace` rather than `history.replaceState` so vue-router's own `route.query` is
 * updated too — otherwise the value would stay visible to anything reading the route.
 */
export const stripLandingUtmContent = async (router: Router) => {
  await router.isReady()

  const { utm_content: utmContent, ...restQuery } = router.currentRoute.value.query
  if (utmContent === undefined) return

  landingUtmContent = Array.isArray(utmContent) ? (utmContent[0] ?? '') : (utmContent ?? '')

  await router.replace({
    path: router.currentRoute.value.path,
    query: restQuery,
    hash: router.currentRoute.value.hash,
  })
}
